import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {AREA_OPTIONS, PROVINCE_OPTIONS} from "@app/constants/Provinces";
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import {capitalizeName, optionsToString, stringToOption} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";
import {JobServiceTypeOptions, JobStatusOptions} from "@pages/job/common/Constant";
import {requestGetJobBasicInfo} from "@app/services/JobService";
import {callApiSaveJob} from "@pages/job/common/Services";
import {CandidateDetailLanguageMode} from "@app/constants/Tabs";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import {requestGetEmployer} from "@app/services/EmployerService";
import {CANDIDATE_NATIONALITIES} from "@app/constants/Nationality";

const JobBasicContent = (props) => {
    const [job, setJob] = useState({input_job_basic:{}});
    const [employer, setEmployer] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {jobInput, employerId, mode, onChange} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const changeSomeOptionValueToString = (inputJobBasic={}) => {
        const strJobBasic = cloneDeep(inputJobBasic)
        strJobBasic.service_type = strJobBasic.service_type ? strJobBasic.service_type.value : ''
        strJobBasic.job_status = strJobBasic.job_status ? strJobBasic.job_status.value : ''
        strJobBasic.local_province = optionsToString(strJobBasic.local_province)
        strJobBasic.candidate_nationality = optionsToString(strJobBasic.candidate_nationality)
        strJobBasic.local_area = optionsToString(strJobBasic.local_area)
        return strJobBasic
    }

    const onChangeJobCallBack = () => {
        const changeJob = cloneDeep(job)
        changeJob.input_job_basic = changeSomeOptionValueToString(changeJob.input_job_basic)
        if (onChange) {
            onChange(changeJob)
        }
    }

    const fetchJobBasicInfo = async (jobId) => {
        if (jobId) {
            const res = await requestGetJobBasicInfo({job_id: jobId})
            // const changeJob = {...jobInput}
            const inputJobBasic = res.content
            inputJobBasic.service_type = inputJobBasic.service_type ? {
                value: inputJobBasic.service_type,
                label: inputJobBasic.service_type
            }: ''

            inputJobBasic.job_status = inputJobBasic.job_status ? {
                value: inputJobBasic.job_status,
                label: inputJobBasic.job_status
            }: ''
            inputJobBasic.local_province = stringToOption(inputJobBasic.local_province)
            inputJobBasic.candidate_nationality = stringToOption(inputJobBasic.candidate_nationality)
            inputJobBasic.local_area = stringToOption(inputJobBasic.local_area)
            const changeJob = {...jobInput}
            changeJob.input_job_basic = inputJobBasic
            setJob(changeJob)
        }
    };

    const defaultJobName = (emp, jo) => {
        if (emp.brief_name && jo.job_title) {
            return emp.brief_name + "." + jo.job_title
        }

        return emp.brief_name ? emp.brief_name : jo.job_title
    }

    const fetchEmployer = async (id) => {
        const res = await requestGetEmployer({employer_id: id});
        const emp = res.content
        if (emp) {
            setEmployer(emp)

            if (!job.id) {
                job.input_job_basic.job_name = defaultJobName(emp, job);
                job.input_job_basic.service_type = {value: "Headhunt", label: "Headhunt"}
                job.input_job_basic.local_province = stringToOption(emp.local_province)
                job.input_job_basic.candidate_nationality = stringToOption(emp.candidate_nationality)
                job.input_job_basic.local_area = stringToOption(emp.local_area)
                setJob({...job})
                onChangeJobCallBack()
            }
        }
    };

    useEffect(async () => {
        if (jobInput && mode !== CandidateDetailLanguageMode.SEARCH) {
            const jobInfo = {...jobInput}
            if (!jobInfo.input_job_basic) {
                jobInfo.input_job_basic = {}
            }

            setJob(jobInfo)

            if (jobInput.id) {
                await fetchJobBasicInfo(jobInput.id)
            }
        }
    }, [jobInput]);

    useEffect(async () => {
        if (employerId && mode !== CandidateDetailLanguageMode.SEARCH) {
            fetchEmployer(employerId)
        }
    }, [employerId]);

    const onSave= () => {
        const jobBody = {job_id: jobInput.id, job_title: job.job_title}
        jobBody.input_job_basic = changeSomeOptionValueToString(job.input_job_basic)
        callApiSaveJob(jobBody,  (res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                if (!job.id) {
                    const changeJob = res.content
                    job.id = changeJob.id
                    setJob({...job})
                    onChangeJobCallBack()
                }
            }
        })
    }

    const onChangeJobInfo = (fieldName, value) => {
        job[fieldName] = value

        // Trường hợp sửa job title => auto sửa job name theo job title
        if (!job.id && mode !== CandidateDetailLanguageMode.SEARCH && fieldName === 'job_title') {
            job.input_job_basic.job_name = defaultJobName(employer, job)
        }
        setJob({...job})
        onChangeJobCallBack()
    };

    const onChangeJobBasicInfo = (fieldName, value) => {
        job.input_job_basic[fieldName] = value

        // Trường hợp add job, điền sẵn 1 số trường
        if (!job.id && mode !== CandidateDetailLanguageMode.SEARCH) {
            if (fieldName === 'work_address') {
                job.input_job_basic.work_address_to_send = value
            }
        }

        setJob({...job})

        onChangeJobCallBack()
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Thông tin cơ bản</h3>
                <div className='card-tools'>
                    {mode !== CandidateDetailLanguageMode.SEARCH &&
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                    }
                </div>
            </div>
            <div className='card-body px-0 py-1'>
                {job.employer_id &&
                <div className='input-group'>
                    <label className={'w-100'}>Employer ID: <a href={`/employer/edit/${job.employer_id}`}>{job.employer_id}</a></label>
                </div>
                }

                {job.id &&
                <div className='input-group'>
                    <label className={'w-100'}>Job ID: {job.id}</label>
                </div>
                }

                {job.input_job_basic.created_date_time &&
                <div className='input-group'>
                    <label className={'w-100'}>Job Date: {job.input_job_basic.created_date_time}</label>
                </div>
                }
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Tên Employer</label>*/}
                {/*    <input type='text' className='form-control'*/}
                {/*           value={job["name"] ? job["name"] : ''}*/}
                {/*           name={"name"}*/}
                {/*           onChange={event => onChangeJobBasicInfo("name", event.target.value)}/>*/}
                {/*</div>*/}
                {/*<div className='input-group mt-3'>*/}
                {/*    <label className={'w-100'}>Tên Employer (brief)</label>*/}
                {/*    <input type='text' className='form-control'*/}
                {/*           value={job["brief_name"] ? job["brief_name"] : ''}*/}
                {/*           name={"brief_name"}*/}
                {/*           onChange={event => onChangeJobBasicInfo("brief_name", event.target.value)}/>*/}
                {/*</div>*/}
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Title</label>
                    <input type='text' className='form-control'
                           value={job["job_title"] ? job["job_title"] : ''}
                           name={"job_title"}
                           disabled={!userLoginInfo.is_superuser}
                           onChange={event => onChangeJobInfo("job_title", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Title (to send)</label>
                    <input type='text' className='form-control'
                           value={job.input_job_basic["job_title_to_send"] ? job.input_job_basic["job_title_to_send"] : ''}
                           name={"job_title_to_send"}
                           onChange={event => onChangeJobBasicInfo("job_title_to_send", event.target.value)}/>
                    <AllUserInputField arrInfo={job.input_job_basic.all_other_user_input} field='job_title_to_send' canDelete={false}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Name</label>
                    <input type='text' className='form-control'
                           disabled={!userLoginInfo.is_superuser}
                           value={job.input_job_basic["job_name"] ? job.input_job_basic["job_name"] : ''}
                           name={"job_name"}
                           onChange={event => onChangeJobBasicInfo("job_name", event.target.value)}/>
                </div>

                {userLoginInfo.is_superuser &&
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Loại dịch vụ</label>
                    <div style={{width: '100%'}}>
                        <Select options={JobServiceTypeOptions}
                                value={job.input_job_basic.service_type}
                                onChange={value => {
                                    onChangeJobBasicInfo("service_type", value);
                                }}
                        />
                    </div>
                </div>
                }

                <div className='input-group mt-3'>
                    <label className={'w-100'}>Job Status</label>
                    <div style={{width: '100%'}}>
                        <Select options={JobStatusOptions}
                                value={job.input_job_basic.job_status}
                                isDisabled={!userLoginInfo.is_superuser}
                                onChange={value => {
                                    onChangeJobBasicInfo("job_status", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Quốc tịch của UV</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={CANDIDATE_NATIONALITIES} isMulti
                                value={job.input_job_basic.candidate_nationality}
                                isDisabled={!userLoginInfo.is_superuser}
                                onChange={value => {
                                    onChangeJobBasicInfo("candidate_nationality", value);
                                }}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Location (Tỉnh)</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={PROVINCE_OPTIONS} isMulti
                                value={job.input_job_basic.local_province}
                                isDisabled={!userLoginInfo.is_superuser}
                                onChange={value => {
                                    onChangeJobBasicInfo("local_province", value);
                                }}
                        />
                    </div>
                </div>
                {job.id &&
                <div className='input-group mt-3'>
                    <label className={'w-100'}><b>Location (Miền)</b></label>
                    <div style={{width: '100%'}}>
                        <Select options={AREA_OPTIONS} isMulti
                                value={job.input_job_basic.local_area}
                                isDisabled={!userLoginInfo.is_superuser}
                                onChange={value => {
                                    onChangeJobBasicInfo("local_area", value);
                                }}
                        />
                    </div>
                </div>
                }
                {mode !== CandidateDetailLanguageMode.SEARCH &&
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Địa điểm LV</label>
                    <input type='text' className='form-control'
                           value={job.input_job_basic["work_address"] ? job.input_job_basic["work_address"] : ''}
                           disabled={!userLoginInfo.is_superuser}
                           name={"work_address"}
                           onChange={event => onChangeJobBasicInfo("work_address", event.target.value)}/>
                </div>
                }
                {mode !== CandidateDetailLanguageMode.SEARCH &&
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Địa điểm LV (to send)</label>
                    <input type='text' className='form-control'
                           value={job.input_job_basic["work_address_to_send"] ? job.input_job_basic["work_address_to_send"] : ''}
                           name={"work_address_to_send"}
                           onChange={event => onChangeJobBasicInfo("work_address_to_send", event.target.value)}/>
                    <AllUserInputField arrInfo={job.input_job_basic.all_other_user_input} field='work_address_to_send'
                                       canDelete={false}/>
                </div>
                }
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Lương tối thiểu (trđ)</label>
                    <input type='number' className='form-control'
                           disabled={!userLoginInfo.is_superuser}
                           value={job.input_job_basic["min_salary"] ? job.input_job_basic["min_salary"] : ''}
                           name={"min_salary"}
                           onChange={event => onChangeJobBasicInfo("min_salary", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Lương tối đa (trđ)</label>
                    <input type='number' className='form-control'
                           disabled={!userLoginInfo.is_superuser}
                           value={job.input_job_basic["max_salary"] ? job.input_job_basic["max_salary"] : ''}
                           name={"max_salary"}
                           onChange={event => onChangeJobBasicInfo("max_salary", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Lương thưởng, đãi ngộ (to send)</label>
                    <input type='text' className='form-control'
                           disabled={!userLoginInfo.is_superuser}
                           value={job.input_job_basic["bonus"] ? job.input_job_basic["bonus"] : ''}
                           name={"bonus"}
                           onChange={event => onChangeJobBasicInfo("bonus", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Sếp trực tiếp</label>
                    <input type='text' className='form-control'
                           disabled={!userLoginInfo.is_superuser}
                           value={job.input_job_basic["direct_manager_id"] ? job.input_job_basic["direct_manager_id"] : ''}
                           name={"direct_manager_id"}
                           onChange={event => onChangeJobBasicInfo("direct_manager_id", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Note</label>
                    <input type='text' className='form-control'
                           disabled={!userLoginInfo.is_superuser}
                           value={job.input_job_basic["note"] ? job.input_job_basic["note"] : ''}
                           name={"note"}
                           onChange={event => onChangeJobBasicInfo("note", event.target.value)}/>
                </div>
                {userLoginInfo.is_superuser &&
                    <div className='input-group mt-3'>
                        <label className={'w-100'}>Note (Ad)</label>
                        <input type='text' className='form-control'
                               value={job.input_job_basic["note_ad"] ? job.input_job_basic["note_ad"] : ''}
                               name={"note_ad"}
                               onChange={event => onChangeJobBasicInfo("note_ad", event.target.value)}/>
                    </div>
                }
            </div>
        </div>
    )
}

export default JobBasicContent;
